





import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Miniheader extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly inline!: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/contract/components/miniheader/Miniheader.vue